// extracted by mini-css-extract-plugin
module.exports = {"w1sd509x":"w1sd509x"};